import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = (withToggle) =>
  makeStyles((theme: Theme) => ({
    searchResult: {
      marginBottom: MIDDLE_MARGIN,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    text: {
      fontSize: 14,
      lineHeight: '18px',
      fontWeight: 700,
      color: 'rgba(255, 255, 255, 0.6)',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    icon: {
      display: 'block',
      width: 16,
      height: 15,
      marginRight: 6,
    },
    buttonsWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    filterBtn: {
      color: colorsPalette.gray,
      textTransform: 'uppercase',
      fontSize: 16,
      fontWeight: 'bold',
      padding: '8px 18px',
      borderRadius: 50,
      background: colorsPalette.violetAnalyticsCard,
      '&:hover': {
        background: colorsPalette.violetAnalyticsCard,
      },
      [theme.breakpoints.up('md')]: {
        padding: '14px 24px',
        ...(withToggle && { marginRight: SMALL_MARGIN }),
      },
      [theme.breakpoints.up('xl')]: {
        display: 'none',
      },
    },
  }));

export default useStyles;
